import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useStickyElement } from 'hooks/useStickyElement';
import FilterCards from './FilterCards';

const LeadFilters = ({ filters, setFilter, selected, isSearching, resetSearch }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // Make filter cards sticky after scrolling past.
  const { elementRef, isSticky } = useStickyElement();

  const defaultFilters = [
    {
      id: 'current',
      name: 'Current',
      order: -1,
      count: filters
        ?.filter(el => el.current)
        .reduce((sum, status) => sum + status.count, 0),
    },
    {
      id: 'all',
      name: 'All',
      order: 0,
      count: filters?.reduce((sum, status) => sum + status.count, 0),
    },
  ];
  const customFilters = filters.slice().sort((el1, el2) => el1.order - el2.order);

  const allFilters = [...defaultFilters, ...customFilters];

  const allIndex = allFilters.findIndex(el => el?.id === 'all');

  const setFilterHandler = (index) => {
    if (index !== selectedIndex) {
      setFilter(allFilters[index]?.id);
      setSelectedIndex(index);
      if (isSearching) resetSearch();
    }
  };

  useEffect(() => {
    if (selectedIndex < 0) {
      setSelectedIndex(allFilters.findIndex((el) => selected === String(el.id)));
    }
  }, [selected]);

  return (
    <div ref={elementRef}
      className={clsx('sticky-cards-placeholder', isSticky && 'has-detached-element sticky')}
    >
      <div className={clsx('sticky-cards-container', isSticky && 'sticky')}>
        <FilterCards
          filters={allFilters}
          selected={isSearching ? allIndex : selectedIndex}
          setFilter={setFilterHandler}
          className={isSticky ? 'condensed' : null}
        />
      </div>
    </div>
  );
};

LeadFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  setFilter: PropTypes.func,
  isSearching: PropTypes.bool,
};

LeadFilters.defaultTypes = {};

export default LeadFilters;
